module.exports = "/img/_/_/_/assets/images/creeper/book/common//45.jpg?7ffc54f48540aa45b3ee552a26c8ba14";